import { Link } from "gatsby"
import { StaticQuery, graphql } from "gatsby"
import React from "react"
import Sprite from "../Sprites"
import * as styles from "./customlink.module.css"
import {
  trackEvent,
  trackFbEvent,
  trackPageView,
} from "../../../helpers/general"

const handleTracking = (url, track, fbTrack, type) => {
  track && trackEvent(track.category, track.action, track.label)
  fbTrack && trackFbEvent(fbTrack)

  if (type === "external") {
    trackOutbound(url)
  }
}

const trackOutbound = (url) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "outbound_link", {
      event_category: "engagement",
      event_label: url,
      transport_type: "beacon",
      non_interaction: true,
    })
  }
}

const Button = (props) => {
  const {
    url,
    isModalOpen,
    setIsModalOpen,
    label,
    type,
    content,
    setModalContent,
    setShowRegisterModal,
    brochureType,
    track,
    className,
    fbTrack,
    inline,
    color,
  } = props || {}

  // If this boots up the modal
  if (type === "formModal") {
    return (
      <button
        onClick={() => {
          setShowRegisterModal(true)
        }}
        className={`${styles.btn}`}
      >
        <span>{label}</span>
        <Sprite name="arrow" className={`${styles.btn__icon}`} />
      </button>
    )
  }

  // If this boots up the modal
  if (type === "videoModal") {
    return (
      <button
        onClick={() => {
          if (!isModalOpen) {
            window.dataLayer.push({
              event: "view_lightbox",
              lightbox_name: track,
            })
          }
          setIsModalOpen(!isModalOpen)
          setModalContent(content)
        }}
        className={`${styles.btn}`}
      >
        <span>{label}</span>
        <Sprite name="arrow" className={`${styles.btn__icon}`} />
      </button>
    )
  }

  // If this boots up the modal
  if (type === "modal") {
    return (
      <button
        onClick={() => {
          if (!isModalOpen) {
            window.dataLayer.push({
              event: "view_lightbox",
              lightbox_name: track,
            })
          }
          setIsModalOpen(!isModalOpen)
          setModalContent(content)
        }}
        className={`${styles.btn}`}
      >
        <span>{label}</span>
        <Sprite name="arrow" className={`${styles.btn__icon}`} />
      </button>
    )
  }

  // Anchor link
  if (type === "anchor") {
    return (
      <button
        onClick={() => {
          const anchor = document.querySelector(url)
          if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        }}
        className={`${styles.btn}`}
      >
        <span>{label}</span>
        <Sprite name="arrow" className={`${styles.btn__icon}`} />
      </button>
    )
  }

  // If a normal external link
  if (type === "external") {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`${className}`}
        onClick={() => {
          handleTracking(url, track, fbTrack, type)
        }}
      >
        <span>{label}</span>
      </a>
    )
  }

  // If this is an eternal button
  if (type === "externalBtn") {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.btn}`}
        onClick={() => {
          handleTracking(url, track, fbTrack, type)
        }}
      >
        {label}
      </a>
    )
  }
  // If this is the PDF Download button
  if (type === "pdfDownloadBtn") {
    const buttonStyles =
      color === "black" ? styles.btn + " " + styles.btn__black : styles.btn
    return (
      <StaticQuery
        query={graphql`
          query PDFQuery {
            contentfulSiteOptions(
              id: { eq: "9c0b4e51-306a-5e2e-b740-5de6d62970bc" }
            ) {
              brochure {
                url
                title
                file {
                  url
                }
              }
              brochureSustainability {
                url
                title
                file {
                  url
                }
              }
              progressReports {
                url
                title
                file {
                  url
                }
              }
              sustainabilityRoadmap {
                url
                title
                file {
                  url
                }
              }
              actionPlan {
                url
                title
                file {
                  url
                }
              }
            }
          }
        `}
        render={(data) => {
          // Check if we are using the multiple progress report PDFs
          if (brochureType === "progressReports") {
            const pdfs = data.contentfulSiteOptions.progressReports
            return (
              <div className="flex flex-col space-y-1 items-start">
                {pdfs.map((pdf, index) => (
                  <a
                    download
                    key={index}
                    href={pdf.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${inline ? "hover:underline" : buttonStyles}`}
                    onClick={() => {
                      handleTracking(pdf.url, track, fbTrack, type)
                      if (pdf.url && typeof document !== "undefined") {
                        const fileUrl = pdf.url
                        const url = new URL(fileUrl)
                        trackPageView(pdf.title, fileUrl, url.pathname)
                      }
                    }}
                  >
                    <span>{pdf.title}</span>
                    {inline ? null : (
                      <Sprite
                        name={`${color === "black" ? "download" : "arrow"}`}
                        className={`${styles.btn__icon}`}
                      />
                    )}
                  </a>
                ))}
              </div>
            )
          }
          return (
            <a
              download
              href={data.contentfulSiteOptions[`${brochureType}`].url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${inline ? "hover:underline" : buttonStyles}`}
              onClick={() => {
                handleTracking(
                  data.contentfulSiteOptions[`${brochureType}`].url,
                  track,
                  fbTrack,
                  type
                )
                if (
                  data.contentfulSiteOptions[`${brochureType}`].url &&
                  typeof document !== "undefined"
                ) {
                  const fileUrl =
                    data.contentfulSiteOptions[`${brochureType}`].url
                  const url = new URL(fileUrl)
                  trackPageView(
                    `${data.contentfulSiteOptions[`${brochureType}`].title}`,
                    fileUrl,
                    url.pathname
                  )
                }
              }}
            >
              <span>{label}</span>
              {inline ? null : (
                <Sprite
                  name={`${color === "black" ? "download" : "arrow"}`}
                  className={`${styles.btn__icon}`}
                />
              )}
            </a>
          )
        }}
      />
    )
  }

  // Fallback
  else {
    return (
      <Link to={url} className={`${inline ? "hover:underline" : styles.btn}`}>
        <span>{label}</span>
        {inline ? null : (
          <Sprite name="arrow" className={`${styles.btn__icon}`} />
        )}
      </Link>
    )
  }
}

export default Button
